export default __webpack_public_path__ + "static/media/win.aecb2a2e.mp3";